import React from 'react';
import './SynergyDiagram.css';
import logo from '../../assets/Logo_Prosperian_Noir.png'; // Logo noir pour le diagramme

const SynergyDiagram = () => {
  // Définition des étapes méthodologiques
  const methodSteps = [
    {
      id: 1,
      service: 'Évaluation approfondie',
      description: 'Avant toute action, nous réalisons un scoring complet de votre dispositif commercial existant : structuration de votre process, efficacité de vos messages, pertinence de vos canaux, capacité de traitement des leads et taux de conversion actuel.'
    },
    {
      id: 2,
      service: 'Conception stratégique',
      description: 'Sur base de cette évaluation, nous élaborons votre plan d\'action personnalisé en sélectionnant les leviers à plus fort potentiel pour votre activité : LinkedIn pour le ciblage précis, email pour la séquence d\'engagement, landing pages pour la conversion, ou webinaires pour la démonstration d\'expertise.'
    },
    {
      id: 3,
      service: 'Déploiement multi-canal',
      description: 'Notre collectif d\'experts se met en action pour créer et déployer vos campagnes synchronisées : copywriting percutant, design optimisé, ciblage affiné par l\'IA et orchestration parfaite de tous les touchpoints avec vos prospects.'
    },
    {
      id: 4,
      service: 'Suivi et optimisation',
      description: 'Votre dashboard unifié vous donne accès en temps réel aux performances de chaque canal et de chaque campagne. Notre équipe ajuste en continu les paramètres pour maximiser votre ROI et accélérer votre pipeline commercial.'
    },
    {
      id: 5,
      service: 'Qualification et transfert',
      description: 'Nous qualifions chaque lead généré et organisons les rendez-vous directement dans l\'agenda de vos commerciaux. Vous ne vous concentrez que sur ce qui compte : transformer ces opportunités en contrats signés.'
    }
  ];

  // Définition des couleurs pour chaque étape
  const serviceColors = {
    'Évaluation approfondie': '#FFD966',
    'Conception stratégique': '#B4A7D6',
    'Déploiement multi-canal': '#EA9999',
    'Suivi et optimisation': '#F9CB9C',
    'Qualification et transfert': '#A2D8B0'
  };

  return (
    <section className="synergy-diagram">
      <div className="synergy-container">
        {/* Titre et description en haut */}
        <div className="section-header">
          <h2>Notre méthode</h2>
          <p>Notre méthodologie repose sur un principe simple mais puissant : la prospection efficace n'est pas une question de volume mais d'intelligence stratégique et d'exécution impeccable.</p>
        </div>

        {/* Diagramme et cartes sur la même ligne */}
        <div className="diagram-layout">
          {/* Diagramme à gauche */}
          <div className="center-diagram">
            <div className="diagram-circle outer-circle"></div>
            <div className="diagram-circle middle-circle"></div>
            <div className="diagram-circle inner-circle"></div>
            
            <div className="synergy-logo-container">
              <img src={logo} alt="Prosperian Logo" />
            </div>
            
            {/* Étapes dans le diagramme */}
            <div className="service-node node-step1">
              <div className="service-bubble" style={{ borderColor: serviceColors['Évaluation approfondie'] }}>
                <span>Évaluation</span>
              </div>
            </div>
            
            <div className="service-node node-step2">
              <div className="service-bubble" style={{ borderColor: serviceColors['Conception stratégique'] }}>
                <span>Conception</span>
              </div>
            </div>
            
            <div className="service-node node-step3">
              <div className="service-bubble" style={{ borderColor: serviceColors['Déploiement multi-canal'] }}>
                <span>Déploiement</span>
              </div>
            </div>
            
            <div className="service-node node-step4">
              <div className="service-bubble" style={{ borderColor: serviceColors['Suivi et optimisation'] }}>
                <span>Suivi</span>
              </div>
            </div>
            
            <div className="service-node node-step5">
              <div className="service-bubble" style={{ borderColor: serviceColors['Qualification et transfert'] }}>
                <span>Qualification</span>
              </div>
            </div>
          </div>

          {/* Cartes à droite */}
          <div className="synergy-cards">
            {methodSteps.map((step) => (
              <div key={step.id} className="synergy-card">
                <div className="synergy-header">
                  <div className="service-tag" style={{ borderColor: serviceColors[step.service] }}>
                    {step.service}
                  </div>
                </div>
                <div className="synergy-description">
                  <span className="arrow">→</span> {step.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SynergyDiagram; 